import { useEffect } from 'react';
import ScrollService from 'services/scrollService';
import { isBrowser } from 'utils/browser';

const useActiveLinks = (
  menuClass: string = 'dt-sub-menu__list',
  activeClass: string = 'dt-sub-menu__active'
): void => {
  useEffect(() => {
    let scroller;
    setTimeout(() => {
      if (isBrowser()) {
        scroller = new ScrollService(`.${menuClass}`, { activeClass });
      }
    }, 1000);

    return () => {
      if (scroller) {
        scroller.destroy();
      }
    };
  }, []);
};

export default useActiveLinks;
